import { Analytics } from './analytics';

let emailLink = $('[data-rss-tracking]');

emailLink.click((e) => {
    Analytics.sendEvent('RSS Feeds', $(e.currentTarget).attr('href') , window.location.pathname)
});